import TableHeadings from '../../../components/Common-components/table-headings'
import { Spinner } from '../../../components/Common-components/spinner'
import { useServiceReport } from '../hook/useServiceReport'
import { Pagination } from '../../../components/Pagination'
import { useTranslation } from 'react-i18next'
import { ServiceReportFilters } from '../component/serviceReportFilters'

export const TotalRequestsPerService = () => {
    const { t } = useTranslation()
    const { data, methods } = useServiceReport()
    const { totalReqPerUserTableHead, details, loader, controller, totalCount } = data
    const { handlePagination } = methods
    return (
        <>
            {loader && <Spinner />}
            <section className="filter">
                <ServiceReportFilters data={data} methods={methods} />
            </section>{' '}
            <div className="table-responsive custom_table px-2 flex-fill mt-3 custom_scroll">
                <table className="table cus-table mt-3">
                    <TableHeadings removeTr={true} TableHeadData={totalReqPerUserTableHead} />
                    <tbody>
                        {details?.length ? (
                            details?.map((row, index) => (
                                <tr className="fw-4 font-12" key={row?._id}>
                                    <td align="center">{controller?.rowsPerPage * (controller?.page - 1) + index + 1}</td>
                                    <td align="center">{row?.serviceName || '- -'}</td>
                                    <td align="center">
                                        {row?.businessName || '- -'}
                                        <br />
                                        {row?.vendorName || '- -'}
                                    </td>
                                    <td align="center">{row?.total_count || '- -'}</td>
                                    <td align="center">{row?.pending_status_count || '- -'}</td>
                                    <td align="center">{row?.accepted_status_count || '- -'}</td>
                                    <td align="center">{row?.cancelled_status_count || '- -'}</td>
                                    <td align="center">{row?.completed_status_count || '- -'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={12} align="center">
                                    {t('tableTitle.noRecordFound')}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {totalCount > 10 && (
                <div>
                    <Pagination count={totalCount} controller={controller} setController={handlePagination} />
                </div>
            )}
        </>
    )
}
